import Vue from "vue";

Vue.component("wto-autocomplete-append", {
	props: [],
	data() {
		return {
			data: [
				'Angular',
				'Angular 2',
				'Aurelia',
				'Backbone',
				'Ember',
				'jQuery',
				'Meteor',
				'Node.js',
				'Polymer',
				'React',
				'RxJS',
				'Vue.js'
			],
			filteredData: [],
			selected: '',
			value: '',
		};
	},
	methods: {
		onChange: function (selected) {
			if(selected){
				if (this.selected) this.selected = this.selected + ',';
				this.selected = this.selected + selected;
				this.$nextTick(() => {
					this.value = this.selected;
				})
			}			
		},
		onTyping: function (typed) {
			if(typed){
				this.selected = typed;
				this.value = this.selected;
				this.filteredDataArray();
			}
		},
		filteredDataArray: function() {
			let lastSelected = '';
			let selected = this.selected.split(",");
			selected.forEach(function(item){
				lastSelected = item;
			})

			this.filteredData = this.data.filter((option) => {
				return option
					.toString()
					.toLowerCase()
					.indexOf(lastSelected.toLowerCase()) >= 0
			});
		}
	},
	template: `
      <div>
      <p class="content"><b>Selected:</b> {{ selected }}</p>
      <b-field label="Find a JS framework">
        <b-autocomplete
            v-model="value"
            :data="filteredData"
            placeholder="e.g. jQuery"
            icon="magnify"
            clearable
            open-on-focus
			@typing="onTyping"
            @select="onChange">
          <template #empty>No results found</template>
        </b-autocomplete>
      </b-field>
      </div>
	`
});